/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether an organization has only been invited to an event or has joined it.
 * @export
 */
export const EventOrganizationStatus = {
    Invited: 'invited',
    Joined: 'joined'
} as const;
export type EventOrganizationStatus = typeof EventOrganizationStatus[keyof typeof EventOrganizationStatus];


export function instanceOfEventOrganizationStatus(value: any): boolean {
    for (const key in EventOrganizationStatus) {
        if (Object.prototype.hasOwnProperty.call(EventOrganizationStatus, key)) {
            if (EventOrganizationStatus[key as keyof typeof EventOrganizationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventOrganizationStatusFromJSON(json: any): EventOrganizationStatus {
    return EventOrganizationStatusFromJSONTyped(json, false);
}

export function EventOrganizationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventOrganizationStatus {
    return json as EventOrganizationStatus;
}

export function EventOrganizationStatusToJSON(value?: EventOrganizationStatus | null): any {
    return value as any;
}

export function EventOrganizationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EventOrganizationStatus {
    return value as EventOrganizationStatus;
}

